// @flow

import * as React from "react"
import { connect } from "react-redux"
import Cookies from "js-cookie"

import getSmartFAQ from "../../utils/getSmartFAQ"
import Sidebar from "../../components/Sidebar/Sidebar"
import { getLanguage } from "../../services/options/reducer"
import { logout, userSelector } from "../../services/user"
import type User from "../../records/User"
import { toggleSmartFAQ, type HelpArticle } from "./services/SmartFAQDuck"
import { bidSelector } from "../../../mmb/scenes/AccountBooking/components/Booking/services/selector"
import { brandingIdSelector } from "../../services/branding/selectors"
import { bannersConfigSelector } from "../../services/remoteConfig"
import maybeTranslate from "../../../../app/scripts/tools/maybeTranslate"
import { hideModal, showModal } from "../../services/modals/actions"
import type { ModalsState } from "../../services/modals/reducer"
import config from "../../consts/config"
import { KW_AUTH_TOKEN, UA_SESSION_TOKEN } from "../../consts/auth"
import { TAB_TYPES } from "../../consts/account"
import cuckoo from "../../services/cuckoo/cuckoo"

type ComponentProps = {||}

type ContainerHandlers = {
  toggleSmartFAQ: boolean => void,
  hideBanner: () => void,
  onLogin: () => void,
  onLogout: () => Promise<*>,
}

type ContainerProps = {|
  isOpen: boolean,
  article: ?HelpArticle,
  version: string,
  translations: {
    [key: string]: string,
  },
  language: string,
  user: ?User,
  kwAuthToken: ?string,
  loginToken: ?string,
  bid: ?number,
  brand: string,
  banners: string[],
  modals: ModalsState,
  enableChat: boolean,
  hideBelowModals: boolean,
|}

type Props = ContainerProps & ContainerHandlers & ComponentProps

type State = {
  SmartFAQ: ?React.ComponentType<any>,
}

class SmartFAQHelp extends React.Component<Props, State> {
  state = {
    SmartFAQ: null,
  }

  componentDidMount = async () => {
    try {
      const smartFAQ = await getSmartFAQ("SmartFAQApp", this.props.version)

      if (typeof smartFAQ === "function") {
        this.setState({ SmartFAQ: smartFAQ })
        return
      }

      throw new Error("Unexpected: SmartFAQ script loaded but no FAQ component")
    } catch (e) {
      cuckoo.error(
        {
          category: "General",
          action: "smartFAQNotLoaded",
          destinations: { logmole: false, exponea: false, ga: false, bigQuery: true },
        },
        {
          error: String(e),
          reason: "SmartFAQ script was not loaded.",
        },
      )
    }
  }

  onToggle = (shouldBeOpen: boolean) => {
    this.props.toggleSmartFAQ(shouldBeOpen)
  }

  render() {
    const { SmartFAQ } = this.state

    if (!SmartFAQ) {
      return null
    }

    const { props } = this
    const simpleToken = props.bid ? Cookies.get(`simple_token-${props.bid}`) : null
    const isWide = Boolean(props.user || simpleToken)

    return (
      <Sidebar
        show={props.isOpen}
        renderAlways
        onHide={() => this.onToggle(false)}
        wide={isWide}
        hideBelowModals={props.hideBelowModals}
        disableAnimationOnSmallScreen={isWide}
        disableAnimationOnTinyScreen
      >
        <SmartFAQ
          isOpen={props.isOpen}
          openArticle={props.article && props.article.id}
          log={(e, p) => cuckoo.nitro(e, p)}
          onToggle={this.onToggle}
          onLogin={props.onLogin}
          onLogout={props.onLogout}
          user={props.user}
          language={props.language}
          translations={props.translations}
          brand={props.brand}
          bid={props.bid}
          enableChat={props.enableChat}
          chatConfig={
            window.SP_GLOBALS.SKYPICKER_ENV === "production" && !window.SP_GLOBALS.IS_STAGING
              ? config.smartFAQChatConfig_PROD
              : config.smartFAQChatConfig_DEV
          }
          loginToken={props.loginToken}
          kwAuthToken={props.kwAuthToken}
          simpleToken={simpleToken}
          emergencies={props.banners}
        />
      </Sidebar>
    )
  }
}

const stateToProps = (state): ContainerProps => {
  const user = userSelector(state)
  const bannersConfig = bannersConfigSelector(state)
  const rawBid = bidSelector(state)
  const bid = Number.isFinite(rawBid) ? rawBid : null
  const widgetState = state.smartFAQ.widget

  return {
    user,
    enableChat: state.splitster.get("SMART_FAQ_CHAT").value === "on",
    hideBelowModals: state.smartFAQ.hideBelowModals,
    modals: state.modals,
    banners: bannersConfig.banners.map(maybeTranslate),
    loginToken: Cookies.get(UA_SESSION_TOKEN),
    kwAuthToken: Cookies.get(KW_AUTH_TOKEN),
    language: getLanguage(state),
    bid,
    translations: state.translations,
    brand: brandingIdSelector(state),
    version: state.splitster.get("SMART_FAQ_VERSION").value,
    isOpen: widgetState.open,
    article: widgetState.article,
  }
}

const dispatchToProps: (Dispatch<*>) => ContainerHandlers = dispatch => ({
  toggleSmartFAQ: (shouldBeOpen: boolean) => dispatch(toggleSmartFAQ(shouldBeOpen)),
  onLogin: () => dispatch(showModal("login", { activeTab: TAB_TYPES.SIGN_IN, type: "help" })),
  onLogout: () => dispatch(logout()),
  hideBanner: () => dispatch(hideModal("exponea")),
})

// $FlowFixMe TODO: plz add type when updating
export default connect(
  stateToProps,
  dispatchToProps,
)(SmartFAQHelp)
